import React, { useContext, useEffect, useMemo } from 'react'

import FlightSearchWidgetMobile from 'components/Flights/FlightsSearch/SearchWidget/FlightSearchWidgetMobile'
import ModalProvider from 'contexts/ModalProvider'
import { useAppSelector } from 'hooks/reduxHooks'
import { isMultiCityEnabled } from 'selectors/flightsSelectors'
import GeoContext from 'contexts/geoContext'
import { DISABLED_MULTI_CITY_REGION_CODES } from 'constants/flight'
import { connect } from 'react-redux'
import { FlightSearchWidgetActions } from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetStateReducer'
import FlightSearchWidgetDispatchContext from 'contexts/Flights/FlightSearchWidget/flightSearchWidgetDispatchContext'

interface MappedStateProps {
  selectedTravellerEmployeeIds?: Array<string>
  selectedTravellerGuestCount?: number
}

function FlightsTabContent(props: MappedStateProps) {
  const { selectedTravellerEmployeeIds, selectedTravellerGuestCount } = props

  const showMultiCity = useAppSelector(isMultiCityEnabled)
  const { currentRegionCode } = useContext(GeoContext)
  const flightsDispatch = useContext(FlightSearchWidgetDispatchContext)

  const isMultiCityRegionEnabled = useMemo(() => {
    return !DISABLED_MULTI_CITY_REGION_CODES.includes(currentRegionCode)
  }, [currentRegionCode])

  const multiCityEnabled = showMultiCity && isMultiCityRegionEnabled

  useEffect(() => {
    if (selectedTravellerEmployeeIds && selectedTravellerGuestCount !== undefined) {
      const occupants: App.Occupants = {
        adults: (selectedTravellerEmployeeIds.length + selectedTravellerGuestCount) || 1,
        children: 0,
        infants: 0,
        childrenAge: [],
      }
      flightsDispatch({ type: FlightSearchWidgetActions.SET_OCCUPANTS, occupants })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- only run on mount
  }, [flightsDispatch])

  return <ModalProvider>
    <FlightSearchWidgetMobile showMultiCity={multiCityEnabled} />
  </ModalProvider>
}

export default connect<MappedStateProps, undefined, undefined, App.State>((appState) => {
  return {
    selectedTravellerEmployeeIds: appState.businessTraveller.selectedTravellerEmployeeIds,
    selectedTravellerGuestCount: appState.businessTraveller.selectedTravellerGuestCount,
  }
})(FlightsTabContent)
